import { Component, Input, OnInit } from '@angular/core';
import { LetterRequestCustomer_History_Interface } from 'src/app/Interface/LetterRequestCustomer_History_Interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-LetterRequestCustomerHistory',
  templateUrl: './LetterRequestCustomerHistory.component.html',
  styleUrls: ['./LetterRequestCustomerHistory.component.css']
})
export class LetterRequestCustomerHistoryComponent implements OnInit {

  constructor() { }

  BaseUrl:String=environment.BaseUrl

  @Input() DataList_History:Array<LetterRequestCustomer_History_Interface>=[]

  ngOnInit() {
  }

}
